import React, { useState, useEffect, useRef } from "react";
import "../../../6729.css";

// Front and Back Images for FF6724

import image1 from "../../../images/Engine-car/synthetic/6724/pictures_FF6724_1_green_front_1200.jpg";
import image2 from "../../../images/Engine-car/synthetic/6724/pictures_FF6724-1_green_back_1200.jpg";

import image3 from "../../../images/Engine-car/synthetic/6724/pictures_FF6724-4_green_front_1200.jpg";
import image4 from "../../../images/Engine-car/synthetic/6724/pictures_FF6724-4_green_back_1200.jpg";

import image5 from "../../../images/Engine-car/synthetic/6724/pictures_FF6724-20_green_front_1200.jpg";
import image6 from "../../../images/Engine-car/synthetic/6724/pictures_FF6724-20_green_back_1200.jpg";

import image7 from "../../../images/Engine-car/synthetic/6724/pictures_FF6724-60_green_front_1200.jpg";
import image8 from "../../../images/Engine-car/synthetic/6724/pictures_FF6724-60_green_back_1200.jpg";

import image9 from "../../../images/Engine-car/synthetic/6724/pictures_FF6724-DR_green_front_1200.jpg";
import image10 from "../../../images/Engine-car/synthetic/6724/pictures_FF6724-DR_green_back_1200.jpg";


const images = [
  { src: image1, alt: "Front" },
  { src: image3, alt: "Back" },
  { src: image5, alt: "Front 4L" },
  { src: image7, alt: "Back 4L" },
  { src: image9, alt: "Back 4L" },

];

const packageSlides = [
  { images: [image1, image2] },
  { images: [image3, image4] },
  { images: [image5, image6] },   // 1L
  { images: [image7, image8] },   // 20L
  { images: [image9, image10] },  // 60L

];

const TDS_URL = "https://www.fanfaro.de/create-pdf/12";

const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF6724_-_FANFARO 6724 NSX 0W-20_(SK).pdf" }
];


export default function ImageWithContent() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSDS, setShowSDS] = useState(false);

  const [packageIndex, setPackageIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  const slideInterval = useRef(null);
  const slideDuration = 4000;

  useEffect(() => {
    startSlideTimer();
    return () => clearInterval(slideInterval.current);
  }, []);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, slideDuration);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    clearInterval(slideInterval.current);
    startSlideTimer();
  };

  const nextImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev + 1) % total);
  };

  const prevImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  return (
    <>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "32px",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >

      {/* LEFT IMAGE CAROUSEL */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://amzn.in/d/056lp4yO"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>

      {/* RIGHT CONTENT */}
      <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
        <h2>FANFARO NSX 0W-20 6724</h2>

        <p>
          Innovative energy-saving premium bi-synthetic engine oil (PAO + esters) for modern gasoline engines. Designed to meet the requirements of American, Japanese and Korean automakers.

        </p>

        <p><strong>Product properties:</strong></p>

        <ul style={{ paddingLeft: "20px" }}>
         
          <li>Exceptional fuel economy thanks to reduced high-temperature HTHS viscosity and optimized anti-friction properties.</li>
          <li>Highly effective additive package and low-viscosity bi-synthetic base provide reliable cold starts even in severe conditions, significantly reducing engine starting wear.</li>
          <li>Excellent washing and dispersing properties combined with high thermo-oxidative stability effectively prevent deposits and keep engine parts clean throughout the oil replacement interval.</li>
          <li>Ester components offer outstanding anti-wear protection due to strong oil film strength and excellent pumpability, extending engine life even in start-stop driving modes.</li>
          <li>Special formulation for turbocharged direct-injection engines minimizes the risk of LSPI (Low-Speed Pre-Ignition).</li>
          <li>Suitable for engines with extended (Long Life) or conventional oil change intervals.</li>
          <li>Designed for gasoline engines in cars, light SUVs, vans, and light trucks requiring API SP (RC) / ILSAC GF-6A performance.</li>
          <li>Recommended for vehicles from CHRYSLER, MITSUBISHI, MAZDA, SUZUKI, TOYOTA, HONDA, SUBARU, and NISSAN.</li>
          <li>Not suitable for heavy trucks or similar large vehicles.</li>
        </ul>

        <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
          CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
        </p>

        {/* SPECIFICATIONS */}
        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          <div>
            <b>Specifications</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>SAE 0W-20</li>
              <li>API SP (RC)</li>
              <li>ILSAC GF-6A</li>
            </ul>
          </div>


          <div>
            <b>Recommendation</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>HONDA HTO-06</li>
              <li>GM Dexos1 Gen 3</li>
              <li>GM 6094M</li>
              <li>CHRYSLER MS-6395</li>
              <li>CHRYSLER MS-13340</li>
              <li>JAGUAR STJLR.51.5122</li>
              <li>LAND ROVER STJLR.51.5122</li>
              <li>FORD WSS-M2C947-A</li>
              <li>FORD WSS-M2C947-B1</li>
              <li>INFINITI</li>
              <li>LEXUS</li>
              <li>MAZDA</li>
              <li>SUZUKI</li>
            </ul>
          </div>

          <div>
            <b>PACKAGES:</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(0);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1L (FF6724-1)
                </span>
              </li>
              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(1);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  4L (FF6724-4)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(2);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  20L (FF6724-20)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(3);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  60L (FF6724-60)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(4);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  208L (FF6724-DR)
                </span>
              </li>

              
            </ul>
          </div>
          <div>
            <b>SDS & TDS</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSDS(true);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  📄 SDS
                </a>
              </li>

              <li>
                <a
                  href={TDS_URL}
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  🖨️ TDS
                </a>
              </li>

            </ul>
          </div>

        </div>

        {/* PACKAGES */}
        {/* <p style={{ marginTop: "20px", fontWeight: "bold" }}>
          PACKAGES (ARTICLE NUMBER):
        </p>

        <ul style={{ paddingLeft: "20px" }}>

          <li>
            <span
              style={{cursor: "pointer" }}
              onClick={() => {
                setPackageIndex(0);
                setImageIndex(0);
                setShowModal(true);
              }}
            >
              20L (FF6201-1)
            </span>
          </li>

          <li>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                setPackageIndex(1);
                setImageIndex(0);
                setShowModal(true);
              }}
            >
              60L (FF6201-20)
            </span>
          </li>

          <li>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                setPackageIndex(2);
                setImageIndex(0);
                setShowModal(true);
              }}
            >
              208L (FF6201-60)
            </span>
          </li>

          <li>
            <span
              style={{cursor: "pointer" }}
              onClick={() => {
                setPackageIndex(3);
                setImageIndex(0);
                setShowModal(true);
              }}
            >
              1000L (FF6201-DR)
            </span>
          </li>

        </ul> */}
      </div>

      {/* MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              width: "500px",
              borderRadius: "8px",
              position: "relative",
            }}
          >

            <span
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "15px",
                top: "10px",
                cursor: "pointer",
                fontSize: "22px",
              }}
            >
              ✕
            </span>

            <img
              src={packageSlides[packageIndex].images[imageIndex]}
              alt="package"
              style={{
                width: "100%",
                maxHeight: "450px",
                objectFit: "contain",
              }}
            />

            <div style={{ textAlign: "center", marginTop: "20px" }}>

              <button onClick={prevImage}>◀</button>

              <span style={{ margin: "0 15px" }}>
                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
              </span>

              <button onClick={nextImage}>▶</button>

            </div>

          </div>
        </div>
      )}

       {showSDS && (
        <div className="sds-overlay" onClick={() => setShowSDS(false)}>
          <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
            {/* Close Icon */}
            <button
              className="sds-close-icon"
              onClick={() => setShowSDS(false)}
              aria-label="Close SDS"
            >
              ×
            </button>

            <h3>SDS – FANFARO 6724</h3>

            <div className="sds-grid">
              {SDS_FILES.map((file) => (
                <a
                  key={file.code}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file.code}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
    </>
  );
}



